/** Session flag read by SupportChatWidget when route state alone is not enough. */
export const OPEN_CHAT_SUPPORT_SESSION_KEY = "open_chat_support_from_navigation";
/** Optional composer text applied when the support chat opens. */
export const OPEN_CHAT_SUPPORT_DRAFT_KEY = "open_chat_support_draft_message";

/**
 * Opens the global support chat on the current page (no redirect to dashboard).
 * `draftMessage` is placed in the chat input so the user can send it.
 */
export function openSupportChatOnCurrentPage(
  navigate,
  pathname,
  search = "",
  draftMessage = ""
) {
  try {
    sessionStorage.setItem(OPEN_CHAT_SUPPORT_SESSION_KEY, "1");
    const draft = String(draftMessage || "").trim();
    if (draft) sessionStorage.setItem(OPEN_CHAT_SUPPORT_DRAFT_KEY, draft);
    else sessionStorage.removeItem(OPEN_CHAT_SUPPORT_DRAFT_KEY);
  } catch (_) {}
  navigate(`${pathname}${search || ""}`, { state: { openChatSupport: true } });
}
